import { z } from 'zod';
import { validator } from '@xeppt/xeppt-sdk';

interface IProps {
    messages: {
        email: string;
        mfa: string;
    };
    isMFA: boolean;
}

export const signInValidation = ({ messages, isMFA }: IProps) => {
    if (!isMFA) {
        return z.object({
            email: validator.email(messages.email)
        });
    } else {
        return z.object({
            mfaCode: z.string()
        });
    }
};
